/**
 * Non-breaking space character (Unicode U+00A0, character code 160)
 * Used to prevent line breaks in formatted numbers with space separators
 */
const NBSP = '\u00A0';

/**
 * @description
 * Normalizes regular space to non-breaking space (NBSP) to prevent line wrapping.
 * This matches Intl.NumberFormat behavior for space-separated number formats.
 *
 * @param separator - Separator character to normalize
 * @returns Normalized separator (NBSP if input was regular space, otherwise unchanged)
 *
 * @example
 * normalizeSpaceSeparator(' ')  // returns '\u00A0' (NBSP)
 * normalizeSpaceSeparator(',')  // returns ','
 * normalizeSpaceSeparator('.')  // returns '.'
 */
export function normalizeSpaceSeparator(separator: string): string {
    return separator === ' ' ? NBSP : separator;
}
